import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import ReportResultLayout from "@/pages/Report/ReportResultLayout";
import BookingInsightTable from "@/pages/Report/BookingInsightTable";
import ReportSummaryCard from "@/pages/Report/ReportSummaryCard";

ChartJS.register(ArcElement, Tooltip, Legend);

interface Dataset {
  label: string,
  data: any[],
  backgroundColor: string[],
  borderColor: string[],
  borderWidth: number
}

export interface PieChartData {
  labels: string[],
  datasets: Dataset[]
}

export interface PieLayoutTableData {
  headers: string[]
  data: any
}

export interface PieLayoutSummaryData {
  totalHours: number
  totalValues: number
}

interface BookingInsightPieLayoutResultProps {
  pieChartData: PieChartData,
  tableData: PieLayoutTableData,
  summaryData: PieLayoutSummaryData,
  overrideHeader?: string
}

const pieOptions = {
  plugins: {
    legend: {
      position: 'bottom' as const,
    }
  }
}

const checkInsightType = (tableHeaders: string[]) => {
  if (tableHeaders.includes('METHODS')) {
    return 'BOOKING_METHOD'
  }
  if (tableHeaders.includes('VENUES')) {
    return 'VENUE'
  }
  return 'COURTS'
}


const BookingInsightPieLayoutResult: React.FC<BookingInsightPieLayoutResultProps>
  = ({
       pieChartData,
       tableData,
       summaryData,
       overrideHeader = null
     }) => (
       <ReportResultLayout
         useHeaderVenue
         useHeaderDate
         overrideHeader={overrideHeader}
         reportType='BOOKING_INSIGHT'
         selectedInsightType={checkInsightType(tableData.headers)}>
         <div>
           {
             summaryData &&
             <div className="j-row">
               <div>
                 <Pie
                   options={pieOptions}
                   data={pieChartData} />
               </div>
               <div className="j-col gap-6">
                 <div className="j-row gap-6">
                   <ReportSummaryCard
                     isPlainText
                     title="Total Hours"
                     total={summaryData?.totalHours ?? 0}
                     classNames="border-l-green-success border-l-[3px]"/>
                   <ReportSummaryCard
                     title="Total Values"
                     total={summaryData?.totalValues ?? 0}
                     classNames="border-l-green-success border-l-[3px]"/>
                 </div>
                 {
                   (tableData?.data?.length) && <BookingInsightTable
                     headers={tableData.headers}
                     data={tableData.data}
                   />
                 }
               </div>
             </div>
           }
         </div>
       </ReportResultLayout>
)

export default BookingInsightPieLayoutResult;